import Helmet from "react-helmet";
import { Layout } from "../components/layout";
import { OfferDetails } from "../components/offer-details";
import { OfferPageProps } from "../types/vino-data-types";
import SEO from "../components/seo/seo";
import config from "../../config.json";
import mapSlugGroup from "../utils/map-slug-group";
import { getExternalUserID } from "../../api/src/utils/auth";
import useAuth from "../hooks/use-auth";
import { RelatedSimilarItems } from "../components/related-offers/RelatedSimilarItems";
import { isProductionAU } from "../utils/environment-helpers";
import RelatedProductItems from "../components/related-offers/RelatedProductItems";

const giftCardPage = ({ pageContext }: OfferPageProps): JSX.Element => {
  const { offer } = pageContext;
  const { user } = useAuth();
  const userId = getExternalUserID(user);
  const seoSubTitle = offer?.isMixed
    ? " - Mixed Case"
    : offer?.category && offer?.category.toLocaleLowerCase() !== "sparkling"
    ? ` - ${offer?.category} Wine`
    : offer?.category
    ? ` - ${offer?.category} `
    : "";
  return (
    <Layout>
      <SEO
        title={`${offer.title || offer.name}${seoSubTitle}`}
        image={offer.cardImage?.url || ""}
        type={"product"}
        description={offer.shortDescription}
        pathname={offer.route?.path || ""}
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "Product",
            name: offer.title || offer.name,
            image: offer.cardImage?.url || "",
            offers: {
              "@type": "Offer",
              url: `${process.env.GATSBY_APP_URL}/products${mapSlugGroup(
                offer
              )}/${offer.route?.slug || ""}`,
              priceCurrency:
                config[process.env.GATSBY_VM_MARKET]?.VM_CURRENCY_CODE || "AUD",
              price: offer?.displayPrice || 0,
              itemCondition: "https://schema.org/NewCondition",
              availability: "https://schema.org/InStock",
            },
          })}
        </script>
      </Helmet>

      <OfferDetails offer={offer} />

      {isProductionAU ? (
        <RelatedProductItems
          indexName={process.env.GATSBY_ALGOLIA_OFFERS_INDEX}
          offerIds={[offer?.id]}
          heading="You might also like…"
          subheading=""
          columns={4}
          limit={4}
          userId={userId}
          hidden={offer?.hidden}
          isSpirit={offer?.isSpirit}
        />
      ) : (
        <RelatedSimilarItems
          offerId={offer?.id}
          skuCodes={offer?.skuCode ? [offer?.skuCode] : []}
          userId={userId}
          heading="You might also like…"
          limit={4}
          columns={4}
          isSpirit={false}
          hidden={offer?.hidden}
        />
      )}
    </Layout>
  );
};

export default giftCardPage;
